import React from 'react';
export function Footer() {
  return <footer className="py-8 px-4 border-t border-brand-gold/30 bg-brand-cream text-center text-brand-graphite/70 text-sm" data-id="element-83">
      <div className="max-w-3xl mx-auto space-y-4" data-id="element-84">
        <p className="text-xs leading-relaxed max-w-2xl mx-auto" data-id="element-85">
          © 2026 FUNCTIONAL PRO™ — All Rights Reserved. This product is
          intended for educational and professional development purposes only.
          It does not replace certified professional training or qualified
          medical advice. Always prioritise client safety and consult
          appropriate professionals where required.
        </p>
        <div className="flex justify-center gap-4 text-xs" data-id="element-86">
          <a href="#" className="hover:text-brand-petrol transition-colors" data-id="element-87">
            Terms & Conditions
          </a>
          <span data-id="element-88">·</span>
          <a href="#" className="hover:text-brand-petrol transition-colors" data-id="element-89">
            Privacy Policy
          </a>
          <span data-id="element-90">·</span>
          <a href="#" className="hover:text-brand-petrol transition-colors" data-id="element-91">
            Contact
          </a>
        </div>
      </div>
    </footer>;
}